// extracted by mini-css-extract-plugin
export default {"wrapper":"SubmitCompositionButton_wrapper__Tvl8m","likeAnimation":"SubmitCompositionButton_likeAnimation__gSKJY"};